import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Password} from "primereact/password";
import {Message} from "primereact/message";
import {login} from "./auth-slice";
import {useTranslate} from "../system/useTranslate";
import BrandLogo from "../system/components/brand-logo";
import AuthBrandPattern from "../system/components/auth-brand-pattern";
import packageJson from "../../package.json";

function Index() {
    const dispatch = useDispatch();
    const translate = useTranslate();
    const {config} = useSelector((state) => state.app);
    const {loading, error} = useSelector((state) => state.auth);
    const [identifier, setIdentifier] = useState("");
    const [password, setPassword] = useState("");
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        document.body.classList.toggle("lang-fa", config?.language === "fa");
    }, [config?.language]);

    const identifierInvalid = submitted && !identifier.trim();
    const passwordInvalid = submitted && !password;

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitted(true);

        if (!identifier.trim() || !password) return;
        await dispatch(login({email: identifier.trim(), password}));
    };

    return (
        <div className={`${config?.dir || "rtl"} relative h-full w-full flex align-items-center justify-content-center surface-ground p-3 md:p-5 overflow-auto`}>
            <AuthBrandPattern/>
            <div className="relative w-full lg:w-9 xl:w-8 flex flex-column lg:flex-row-reverse surface-card border-round-2xl shadow-2 overflow-hidden" style={{zIndex: 1}}>
                <form onSubmit={handleSubmit} className="w-full lg:w-5 p-4 md:p-5 flex flex-column justify-content-center gap-3">
                    <div className="flex justify-content-center mb-3">
                        <BrandLogo variant="mark" className="w-3rem h-3rem" style={{filter: "grayscale(1) brightness(1.5)"}}/>
                    </div>

                    <div className="flex flex-column gap-2 mb-2">
                        <span className="text-3xl font-bold text-900">{translate("sign-in")}</span>
                        <span className="text-sm text-500">{translate("login-description")}</span>
                    </div>

                    {error && <Message className="w-full justify-content-start" severity="error" text={translate(error)}/>}

                    <div className="flex flex-column gap-2">
                        <label htmlFor="auth-identifier" className="text-sm font-medium text-700">{translate("email")}</label>
                        <InputText
                            id="auth-identifier"
                            autoComplete="username"
                            value={identifier}
                            invalid={identifierInvalid}
                            disabled={loading}
                            placeholder={translate("email-input-placeholder")}
                            onChange={(event) => setIdentifier(event.target.value)}
                        />
                        {identifierInvalid && <small className="p-error">{translate("username-invalid")}</small>}
                    </div>

                    <div className="flex flex-column gap-2">
                        <label htmlFor="auth-password" className="text-sm font-medium text-700">{translate("password")}</label>
                        <Password
                            inputId="auth-password"
                            className="w-full"
                            inputClassName="w-full"
                            autoComplete="current-password"
                            value={password}
                            invalid={passwordInvalid}
                            disabled={loading}
                            feedback={false}
                            toggleMask
                            placeholder={translate("password-input-placeholder")}
                            onChange={(event) => setPassword(event.target.value)}
                        />
                        {passwordInvalid && <small className="p-error">{translate("password-invalid")}</small>}
                    </div>

                    <Button type="submit" label={translate("sign-in")} icon="pi pi-sign-in" loading={loading} className="w-full justify-content-center mt-2 gap-2"/>

                    <span className="text-center text-xs text-400 mt-3">{translate("app-version-prefix")} {packageJson.version}</span>
                </form>

                <section className="hidden lg:flex flex-1 flex-column align-items-center justify-content-center surface-ground p-5 gap-4 text-center">
                    <BrandLogo className="w-24rem max-w-full h-auto"/>
                    <div className="flex flex-column gap-2">
                        <span className="text-4xl font-bold text-700">{translate("welcome-to-zofino")}</span>
                        <span className="text-base text-500">{translate("welcome-to-zofino-description")}</span>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Index;
